import {
	createSlice,
	createAsyncThunk,
	createEntityAdapter
} from '@reduxjs/toolkit'

import { envAwarePost } from '../../util/util'

export const getMAXFoodList = createAsyncThunk(
	'getMAXFoodList',
	async () => envAwarePost('api/foods/',{action:'getLibraryFoods'})
)

//Diet CRUD Ops
export const getMAXDiets = createAsyncThunk(
	'getMAXDiets',
	async () => envAwarePost('api/foods/',{action:'getMAXDiets'})
)

export const createMAXDiet = createAsyncThunk(
	'createMAXDiet',
	async payload => envAwarePost('api/foods',{action:'createMAXDiet',...payload})
)

export const editMAXDiet = createAsyncThunk(
	'editMAXDiet',
	async payload => envAwarePost('api/foods',{action:'editMAXDiet',...payload})
)

export const removeMAXDiet = createAsyncThunk(
	'removeMAXDiet',
	async payload => envAwarePost('api/foods',{action:'removeMAXDiet',...payload})
)

//Food CRUD ops

export const createMAXFood = createAsyncThunk(
	'createMAXFood',
	async payload => envAwarePost('api/foods',{action:'createMAXFood',...payload})
)

export const editMAXFood = createAsyncThunk(
	'editMAXFood',
	async payload => envAwarePost('api/foods',{action:'editMAXFood',...payload})
)

export const removeMAXFood = createAsyncThunk(
	'removeMAXFood',
	async payload => envAwarePost('api/foods',{action:'removeMAXFood',...payload})
)

export const addFoodToMAXDiet = createAsyncThunk(
	'addFoodToMAXDiet',
	async payload => envAwarePost('api/foods/',{action:'addFoodToMAXDiet',...payload})
)

export const removeFoodFromMAXDiet = createAsyncThunk(
	'removeFoodFromMAXDiet',
	async payload => envAwarePost('api/foods/',{action:'removeFoodFromMAXDiet',...payload})
)

const foodsAdapter = createEntityAdapter()

const dietsAdapter = createEntityAdapter()

const slice = createSlice({
	name: 'MAXFoods',
	initialState:{
		foods:foodsAdapter.getInitialState({
			status:'idle',
			editor:{
				show:false,
				mode:null,
				id:null
			}
		}),
		diets:dietsAdapter.getInitialState({
			status:'idle',
			show:false
		})
	},
	reducers:{
		toggleDietsModal: (state)=>{ state.diets.show = !state.diets.show },
		setEditor : (state,action)=>{
			state.foods.editor.show = action.payload.show
			state.foods.editor.mode = action.payload.mode
			state.foods.editor.id = action.payload.id
		}
	},
	extraReducers: {
		[getMAXFoodList.pending] : (state,action) => {
			state.foods.status = 'pending'
		},
		[getMAXFoodList.fulfilled] : (state,action) => {
			state.foods.status = 'idle'
			const {data:{foods}} = action.payload
			foodsAdapter.setAll(state.foods,foods)
		},
		[getMAXDiets.pending] : (state,action) => {
			state.diets.status = 'pending'
		},
		[getMAXDiets.fulfilled] : (state,action) => {
			state.diets.status = 'idle'
			const {data:{diets}} = action.payload
			dietsAdapter.setAll(state.diets,diets)
		},
		[createMAXDiet.fulfilled] : (state,action) => {
			const {data:{diet}} = action.payload
			dietsAdapter.upsertOne(state.diets,diet)
		},
		[editMAXDiet.pending] : (state,action)=>{
			const {id,name} = action.meta.arg
			dietsAdapter.updateOne(state.diets,{id,changes:{name}})
		},
		[removeMAXDiet.pending] : (state,action)=>{
			const {id} = action.meta.arg
			dietsAdapter.removeOne(state.diets,id)
		},

		[createMAXFood.fulfilled] : (state,action)=>{
			const {data:{food}} = action.payload
			foodsAdapter.upsertOne(state.foods,food)
		},

		[editMAXFood.pending] : (state,action)=>{
			const {id,update:changes} = action.meta.arg
			foodsAdapter.updateOne(state.foods,{id,changes})
		},

		[removeMAXFood.pending] : (state,action)=>{
			const {id} = action.meta.arg
			foodsAdapter.removeOne(state.foods,id)
		},

		[addFoodToMAXDiet.pending] : (state,action)=>{
			const {food_id,diet_id}  = action.meta.arg
			const diet = state.diets.entities[diet_id]
			const food = state.foods.entities[food_id]
			food.diets.push(diet.name)
		},

		[removeFoodFromMAXDiet.pending] : (state,action)=>{
			const {food_id,diet_id}  = action.meta.arg
			const diet = state.diets.entities[diet_id]
			const food = state.foods.entities[food_id]
			food.diets = food.diets.filter(d=>d!==diet.name)
		}
	}
})

export const {toggleDietsModal,setEditor} = slice.actions

export const {
  selectAll: selectAllFoods,
  selectById: selectFoodById,
  selectIds: selectFoodIds
} = foodsAdapter.getSelectors(state => state.MAXFoods.foods)

export const {
  selectAll: selectAllDiets,
  selectById: selectDietById,
  selectIds: selectDietIds
} = dietsAdapter.getSelectors(state => state.MAXFoods.diets)

export default slice.reducer